module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns-house_access_05-eb791b7d3e4964215cea7037ddc063e3.jpg";